@if (userSettingsData$ | async) {
  <mat-card class="user-profile-settings-card">
    <mat-card-header>
      <mat-card-title class="settings-title">User Details</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form
        class="user-profile-settings-form"
        [formGroup]="userProfileSettingsForm"
        (ngSubmit)="handleSaveChanges()"
      >
        <section class="settings-section">
          <div class="users-details">
            <div class="name-fields">
              <app-input-field
                label="First name"
                formControlName="firstName"
                [errorMessages]="{
                  required: 'First name is required',
                  minlength: 'First name must be at least 2 characters',
                }"
              />

              <app-input-field
                label="Last name"
                formControlName="lastName"
                [errorMessages]="{
                  required: 'Last name is required',
                  minlength: 'Last name must be at least 2 characters',
                }"
              />
            </div>

            <div class="user-contact-fields">
              <app-input-field label="Email" formControlName="email" />

              <app-input-field label="Username" formControlName="username" />

              <app-input-field label="Role" formControlName="role" />
            </div>
          </div>
        </section>

        <mat-divider></mat-divider>

        <section class="settings-section">
          <span class="settings-title">Change password</span>
          <span class="settings-subtitle">
            Only fill the below if you would like to change your password.
          </span>

          <div class="password-fields">
            <app-input-field
              label="New Password"
              placeholder="********"
              type="password"
              autocomplete="new-password"
              formControlName="newPassword"
              [errorMessages]="{
                required: 'Password is required',
                passwordStrength: getPasswordErrorMessage(
                  userProfileSettingsForm.get('newPassword')
                ),
              }"
            />

            <app-input-field
              label="Confirm Password"
              placeholder="********"
              type="password"
              autocomplete="new-password"
              formControlName="confirmPassword"
              [errorMessages]="{
                required: 'Confirm password is required',
                passwordMismatch: 'Passwords do not match',
              }"
            />
          </div>
        </section>

        <div class="form-actions">
          <button
            matButton="filled"
            type="submit"
            [disabled]="userProfileSettingsForm.invalid || userProfileSettingsForm.pristine"
          >
            Save Changes
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
}
